import { render } from "./RemercimentAssemblee.vue?vue&type=template&id=37c56653&scoped=true&ts=true"
import script from "./RemercimentAssemblee.vue?vue&type=script&lang=ts"
export * from "./RemercimentAssemblee.vue?vue&type=script&lang=ts"

import "./RemercimentAssemblee.vue?vue&type=style&index=0&id=37c56653&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c56653"]])

export default __exports__